export enum GridSizeEnum {
  NORMAL = 'NORMAL',
  LARGE = 'LARGE',
}
